import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const IdeaCardRoot = superstyled({
  name: 'IdeaCard',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['selected'],
  styles: ({ theme, selected }) => ({
    padding: theme.spacing(2.5, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    borderBottom: `1px solid ${theme.palette.border.main}`,
    backgroundColor: selected
      ? theme.palette.background.grey.main
      : theme.palette.background.grey.light,
    color: selected ? theme.palette.info.main : theme.palette.text.primary,

    '&:hover': {
      backgroundColor: theme.palette.background.grey.main
    },

    '&:active': {
      backgroundColor: selected
        ? theme.palette.background.grey.main
        : theme.palette.background.grey.light
    }
  })
});

export const IdeaTitle = superstyled({
  name: 'IdeaCard',
  slot: 'Title',
  tag: Text,
  propsNeeded: ['selected'],
  styles: () => ({})
});
